// extracted by mini-css-extract-plugin
export default {"container":"about_container__lzDcE","body":"about_body__69Wya","desc":"about_desc__YDCLE"};